module.exports = __webpack_public_path__ + "static/media/video-example-left.77b0bb86.png";